'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _WeeklyTimeWindow = require('../iterators/WeeklyTimeWindow');

var WeeklyTimeWindow = _interopRequireWildcard(_WeeklyTimeWindow);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var normalize = function normalize(weekly) {
    if (weekly.length < 2) {
        return weekly;
    }

    var firstWindow = weekly[0];
    if (firstWindow.minuteOfWeek !== 0) {
        return weekly;
    }

    var lastWindow = weekly[weekly.length - 1];
    if (lastWindow.minuteOfWeek + lastWindow.durationMins !== WeeklyTimeWindow.WEEK) {
        return weekly;
    }

    var normalizedWeekly = [];
    for (var i = 1; i < weekly.length - 1; ++i) {
        normalizedWeekly.push(weekly[i]);
    }
    normalizedWeekly.push({
        minuteOfWeek: lastWindow.minuteOfWeek,
        durationMins: lastWindow.durationMins + firstWindow.durationMins
    });
    return normalizedWeekly;
};

var isAlwaysAvailable = function isAlwaysAvailable(weekly) {
    return !weekly || weekly.length === 0 || weekly[0].minuteOfWeek === 0 && weekly[0].durationMins === WeeklyTimeWindow.WEEK;
};

var dailyWindowToString = function dailyWindowToString(dailyWindow) {
    return dailyWindow.minuteOfDay + '+' + dailyWindow.durationMins;
};

var humanizeWeekly = function humanizeWeekly(weekly) {
    if (isAlwaysAvailable(weekly)) {
        return [{
            days: [0, 1, 2, 3, 4, 5, 6],
            window: {
                minuteOfDay: 0,
                durationMins: WeeklyTimeWindow.DAY
            }
        }];
    }

    // Handle overlapping last period
    var normalizedWeekly = normalize(weekly);

    var dailyWindowsByDay = [];
    for (var day = 0; day < 7; ++day) {
        dailyWindowsByDay.push([]);
    }

    // We split > 1day time windows, since we currently don't display Mon 12:00AM - Tuesday 2:00PM. Instead this will be displayed as Mon all day, Tuesday 12AM - 2:00PM
    var weeklyBroken = _lodash2.default.flatMap(normalizedWeekly, function (timeWindow) {
        var ret = [];
        var minuteOfWeek = timeWindow.minuteOfWeek,
            durationMins = timeWindow.durationMins;


        while (durationMins > WeeklyTimeWindow.DAY) {
            var newDurationMins = WeeklyTimeWindow.DAY - minuteOfWeek % WeeklyTimeWindow.DAY;

            // Modulo 10080 because of the normalize
            ret.push({ minuteOfWeek: minuteOfWeek % WeeklyTimeWindow.WEEK, durationMins: newDurationMins });

            minuteOfWeek += newDurationMins;
            durationMins -= newDurationMins;
        }

        if (durationMins > 0) {
            ret.push({ minuteOfWeek: minuteOfWeek % WeeklyTimeWindow.WEEK, durationMins: durationMins });
        }

        return ret;
    });

    return (0, _lodash2.default)(weeklyBroken).map(function (weeklyWindow) {
        var day = Math.floor(weeklyWindow.minuteOfWeek / WeeklyTimeWindow.DAY);
        return {
            day: day,
            window: {
                minuteOfDay: weeklyWindow.minuteOfWeek - day * WeeklyTimeWindow.DAY,
                durationMins: weeklyWindow.durationMins
            }
        };
    }).groupBy(function (dayAndDailyWindow) {
        return dailyWindowToString(dayAndDailyWindow.window);
    }).map(function (dayAndDailyWindows) {
        return {
            days: _lodash2.default.map(dayAndDailyWindows, 'day'),
            window: dayAndDailyWindows[0].window
        };
    }).value();
};

exports.default = humanizeWeekly;


//////////////////
// WEBPACK FOOTER
// ../node_modules/availability/dist/utils/humanizeWeekly.js
// module id = 685
// module chunks = 0